<template>
    <div class="v-container">
      <div class="loadding-spin" v-if="loading">
        <Circle4></Circle4>
      </div>
  
      <div class="card">
        <div class="card-header">
          <h3 v-if="mData.viewMode === 'create'">THÊM MỚI MAIL</h3>
          <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT MAIL</h3>
          <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT MAIL</h3>
        </div>
  
        <div class="card-body">
          <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
            <b-row>
              <b-col md="6">
                <el-form-item label="Mã" prop="code">
                  <el-input
                    v-model="mData.dataForm.code"
                    :disabled="mData.viewMode == 'detail'"
                    @change="mData.dataForm.code = mData.dataForm.code ? mData.dataForm.code.trim() : ''"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Tên mail" prop="name">
                  <el-input
                    v-model="mData.dataForm.name"
                    :disabled="
                      mData.viewMode == 'detail'
                    "
                    @change="mData.dataForm.name = mData.dataForm.name ? mData.dataForm.name.trim() : ''"
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <div class="content-template">
              <el-form-item label="Nội dung template" prop="content">
                <el-input
                  v-model="mData.dataForm.content"
                  :rows="12"
                  type="textarea"
                  placeholder="Nhập nội dung"
                  :disabled="mData.viewMode == 'detail'"
                  @change="mData.dataForm.content = mData.dataForm.content ? mData.dataForm.content.trim() : ''"
                />
              </el-form-item>
              <el-button
                type="primary"
                @click="showMailPreview(mData.dataForm.content)"
                >preview</el-button
              >
            </div>
            
            <el-form-item label="Nội dung ghi chú">
              <el-input
                v-model="mData.dataForm.note"
                :rows="4"
                type="textarea"
                placeholder="Nhập nội dung"
                :disabled="mData.viewMode == 'detail'"
                @change="mData.dataForm.note = this.mData.dataForm.note ? this.mData.dataForm.note.trim() : ''"
              />
            </el-form-item>
  
            <div class="text-center mt-3">
              <el-button
                type="danger"
                plain
                @click="fn_cancel()"
                v-ladda
                v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
                >hủy</el-button
              >
              <el-button
                type="primary"
                @click="createMail()"
                v-ladda
                v-if="mData.viewMode === 'create'"
                >thêm mới</el-button
              >
              <el-button
                type="primary"
                @click="fn_update()"
                v-ladda
                v-if="mData.viewMode === 'update'"
                >cập nhật</el-button
              >
              <el-button
                type="primary"
                @click="fn_back()"
                v-ladda
                v-if="mData.viewMode === 'detail'"
                >quay lại</el-button
              >
            </div>
          </el-form>

          <!-- popup preview mail -->
          <Preview 
            :data="mData.dataMailPreview" 
            :showMail="showMail" 
            :code="mData.dataForm.code"
            :name="mData.dataForm.name"
            @back-popup="backPopup()"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Circle4 } from "vue-loading-spinner";
  import Preview from "./Preview.vue";
  import MethodService from "@/service/MethodService";
  import DataForm from "@/dataForm/dataFormMail";
  import mushroom from "viettoc-api";
  import ValidService from "@/service/ValidService";
  
  export default {
    data() {
      return {
        loading: false,
        mData: {
          viewMode: "create",
          dataForm: MethodService.copyObject(DataForm.dataForm),
          validForm: {
            name: [ValidService.required],
            code: [ValidService.required],
            content: [ValidService.required],
          },
          dataMailPreview: MethodService.copyObject(DataForm.dataMail),
        },
        showMail: false,
        listMeta: [{
          name: undefined,
          content: undefined,
        }],
        htmlEmail: '',
      };
    },
    components: {
      Circle4,
      Preview,
    },
    methods: {
      async getMailId() {
        try {
          const response = await mushroom.mail_template.findByIdAsync({
            id: this.$router.currentRoute.params.id,
          });
          this.mData.dataForm = response.result;
        } catch (e) {
          console.error("Có lỗi: %o", e);
        }
      },
      // reset form
      fn_resetForm() {
        this.$refs.myForm.$el.reset();
      },
      fn_resetDataForm() {
        this.mData.dataForm.name = undefined;
        this.mData.dataForm.code = undefined;
        this.mData.dataForm.content = undefined;
        this.mData.dataForm.note = undefined;
      },
      fn_cancel() {
        this.fn_resetForm();
        this.fn_resetDataForm();
        this.$router.go(-1);
      },
      // thêm mới
      async createMail() {
        const mail_template_object = {
          name: this.mData.dataForm.name.trim(),
          code: this.mData.dataForm.code.trim(),
          content: this.mData.dataForm.content.trim(),
          note: this.mData.dataForm.note ? this.mData.dataForm.note.trim() : undefined,
        };
        console.log("dữ liệu truyền lên: ", mail_template_object);
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            if (this.mData.dataForm.name == undefined) {
              window.toastr.warning("Cần nhập tên mail");
              MethodService.stopLadda();
            } else if (this.mData.dataForm.code == undefined) {
              window.toastr.warning("Cần nhập mã");
              MethodService.stopLadda();
            } else if (this.mData.dataForm.content == undefined) {
              window.toastr.warning("Cần nhập nội dung template");
              MethodService.stopLadda();
            } else {
              try {
                const newId = await mushroom.mail_template.createAsync(
                    mail_template_object
                );
                console.log("Thêm mới thành công, new id: %o", newId);
                window.toastr.success("Thêm mới mail thành công");
                this.$router.push({
                  name: "DanhSachMail",
                });
              } catch (error) {
                console.error("Có lỗi: %o", error);
                if (error.code === 4) {
                  window.toastr.error(this.aLang.no_server);
                  MethodService.stopLadda();
                } else if (error.code === 2) {
                  window.toastr.error("Gặp sự cố tải dữ liệu");
                  MethodService.stopLadda();
                } else if (error.meta.field === '$unique_key') {
                  window.toastr.error("Mã mail đã tồn tại");
                  MethodService.stopLadda();
                } else {
                  window.toastr.error("Đã có lỗi xảy ra");
                  MethodService.stopLadda();
                }
              }
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      },

      // cập nhật
      async fn_update() {
        const mail_template_object = {
          id: this.$router.currentRoute.params.id,
          name: this.mData.dataForm.name.trim(),
          code: this.mData.dataForm.code.trim(),
          content: this.mData.dataForm.content.trim(),
          note: this.mData.dataForm.note ? this.mData.dataForm.note.trim() : undefined,
        };
        console.log("dữ liệu truyền lên: ", mail_template_object);
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            if (this.mData.dataForm.name == undefined) {
              window.toastr.warning("Cần nhập tên mail");
              MethodService.stopLadda();
            } else if (this.mData.dataForm.code == undefined) {
              window.toastr.warning("Cần nhập mã");
              MethodService.stopLadda();
            } else if (this.mData.dataForm.content == undefined) {
              window.toastr.warning("Cần nhập nội dung template");
              MethodService.stopLadda();
            } else {
              try {
                const response = await mushroom.mail_template.partialUpdateAsync(
                    mail_template_object
                );
                if (response.result == this.$router.currentRoute.params.id) {
                  window.toastr.success("Cập nhật mail thành công");
                  this.$router.push({
                    name: "DanhSachMail",
                  });
                } else {
                  window.toastr.warning("Dữ liệu không thay đổi");
                  MethodService.stopLadda();
                }
              } catch (error) {
                MethodService.stopLadda();
                console.error("Có lỗi: %o", error);
                if (error.code === 4) {
                  window.toastr.error(this.aLang.no_server);
                  MethodService.stopLadda();
                } else if (error.code === 2) {
                  window.toastr.error("Máy chủ không phản hồi");
                  MethodService.stopLadda();
                } else if (error.meta.field === '$unique_key') {
                  window.toastr.error("Mã mail đã tồn tại");
                  MethodService.stopLadda();
                } else {
                  window.toastr.error("Đã có lỗi xảy ra");
                  MethodService.stopLadda();
                }
              }
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      },
      // quay lại
      fn_back() {
        this.$router.go(-1);
      },
      showMailPreview(content) {
        const dom = document.createElement('div');
        dom.innerHTML = content;
        const metas = dom.getElementsByTagName('meta');
        const arrMetas = Array.prototype.slice.call(metas);
        this.listMeta = [];
        if(arrMetas) {
          arrMetas.forEach((item) => {
            if(item.name) {
              this.listMeta.push(
                {
                  name: item.name,
                  content: item.content,
                }
              )
            }
          })
        };

        this.mData.dataMailPreview.to = this.listMeta.find(item => item.name === 'template:toEmail') ? this.listMeta.find(item => item.name === 'template:toEmail').content : undefined;
        this.mData.dataMailPreview.test.from = this.listMeta.find(item => item.name === 'template:fromEmail') ? this.listMeta.find(item => item.name === 'template:fromEmail').content : undefined;
        this.mData.dataMailPreview.test.cc = this.listMeta.find(item => item.name === 'template:ccEmail') ? this.listMeta.find(item => item.name === 'template:ccEmail').content : undefined;
        this.mData.dataMailPreview.test.bcc = this.listMeta.find(item => item.name === 'template:bccEmail') ? this.listMeta.find(item => item.name === 'template:bccEmail').content : undefined;
        this.mData.dataMailPreview.test.replyTo = this.listMeta.find(item => item.name === 'template:replyToEmail') ? this.listMeta.find(item => item.name === 'template:replyToEmail').content : undefined;
        
        this.mData.dataMailPreview.subject = dom.getElementsByTagName('title')[0] ? dom.getElementsByTagName('title')[0].innerText : undefined;
        this.mData.dataMailPreview.prod.from = this.listMeta.find(item => item.name === 'template:{@env}fromEmail') ? this.listMeta.find(item => item.name === 'template:{@env}fromEmail').content : undefined;
        this.mData.dataMailPreview.prod.cc = this.listMeta.find(item => item.name === 'template:{@env}ccEmail') ? this.listMeta.find(item => item.name === 'template:{@env}ccEmail').content : undefined;
        this.mData.dataMailPreview.prod.bcc = this.listMeta.find(item => item.name === 'template:{@env}bccEmail') ? this.listMeta.find(item => item.name === 'template:{@env}bccEmail').content : undefined;
        this.mData.dataMailPreview.prod.replyTo = this.listMeta.find(item => item.name === 'template:{@env}replyToEmail') ? this.listMeta.find(item => item.name === 'template:{@env}replyToEmail').content : undefined;
        
        const bodyHtml = dom;
        const test = bodyHtml.getElementsByTagName('img');
        const arrImgs = Array.prototype.slice.call(test);
        if(arrImgs) {
          arrImgs.forEach((item) => {
            const srcImg = this.listMeta.find(el => el.name === item.src);
            item.src = srcImg ? 'data:' + srcImg.content.slice(0, 10) + 'base64,' +  srcImg.content.slice(10): '';
          })
        };
        this.mData.dataMailPreview.content = bodyHtml.innerHTML;
        this.showMail = true;
      },
      backPopup() {
        this.showMail = false;
      },
    },
  
    async created() {
      // kiểm tra loại viewMode
      if (this.$router.currentRoute.name == "ThemMoiMail") {
        this.mData.viewMode = "create";
        this.loading = false;
      }
      if (this.$router.currentRoute.name == "ChiTietMail") {
        this.mData.viewMode = "detail";
        await this.getMailId();
      }
      if (this.$router.currentRoute.name == "CapNhatMail") {
        this.mData.viewMode = "update";
        await this.getMailId();
      }
    },
  };
  </script>
  <style scoped lang="scss">
    .form-space-between {
      display: flex;
    }
    .center-checkbox {
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    .margin-checkbox {
      margin-bottom: 8px;
    }
    .list-node-hide {
      display: flex;
      flex-direction: column;
    }
    .wrapper-node {
      align-items: center;
      border: 1px solid #cec6c5;
      border-radius: 6px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      padding: 0px 10px;
      position: relative;
    }
    .icon-detail {
      position: absolute;
      right: 10px;
      bottom: 9px;
      color: #717378;
      cursor: pointer;
    }
    .content-template {
      position: relative;
      button {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .preview-content {
      font-size: 15px;
      padding: 10px;
    }
    .mail-body {
      margin-top: 10px;
    }
    .preview-address {
      display: flex;
      border-bottom: 1px solid #e4e7ed;
      .preview-content {
        width: 50%;
      }
    }
    .popup-mail-preview {
      .el-form {
        border: 1px solid #e4e7ed;
        .content-left {
          border-right: 1px solid #e4e7ed;
        }
        .mail-subject {
          border-bottom: 1px solid #e4e7ed;
        }
      }
    }
    :deep .el-dialog {
      margin: 50px auto !important;
    }
    .iframe-mail {
      height: 90vh;
    }
  </style>
  